export const getUserToken = (state) => state.auth.user.token;
export const getActionId = (state) => state.betaAction.action.key;
export const getAction = (state) => state.betaAction.action;
export const getUsername = (state) => state.auth.user.display_name;
